import ahoy from 'ahoy.js'

ahoy.configure({
  useBeacon: false,
  trackVisits: false, // visits are tracked server-side
})

ahoy.debug(false)
ahoy.trackAll()
